<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
            <AmountSelectorList />
            <ErrorLabel field="amount" />
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>
          </FormSection>
          <FormSection title="Kiddush Info">
            <FormRow inline style="margin-bottom: 0px">
              <FormLabel for="date">
                For which date would you like to sponsor kiddush?
              </FormLabel>
            </FormRow>
            <FormRow>
              <input
                id="date"
                type="date"
                class="date-input"
                @change="setDailyDate(new Date($event.target.value))"
              />
            </FormRow>
            <br />
            <FormRow>
              <FormLabel class="control-label">
                Kiddush is in honor/commemoration of the following:
              </FormLabel>
            </FormRow>
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.honorOf" />
            </FormRow>
            <br />
            <FormRow>
              <FormLabel for="anonymousCheck">
                <input
                  type="checkbox"
                  id="anonymousCheck"
                  :checked="getValue('custom.anonymous') === 'yes'"
                  @click="setValue('custom.anonymous', $event.target.checked ? 'yes' : 'no')"
                /> If you prefer your sponsorship remain anonymous, please check here
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();
    onMounted(() => {
      // setValue("amount", "180");
      setValue("currency", "USD");
    });

    function setDailyDate(date: Date) {
      setValue(
        "custom.date",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
    }

    return {
      getValue,
      setValue,
      form,
      setDailyDate,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

.vdp-datepicker {
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}
</style>
